import {useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {House} from 'react-bootstrap-icons';
import CallIcon from '@mui/icons-material/Call';
import {useNavigate} from 'react-router-dom';
import styles from './Header.module.scss';

function MobileHeader() {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);

    const navItems = [
        {path: '/', label: 'Главная', icon: <House size={20}/>},
        {path: '/services', label: 'Услуги'},
    ];

    return (
        <>
            <div>
                <Container fluid>
                    <Row className="align-items-center">
                        {/* Логотип */}
                        <Col xs={6}>
                            <div className={styles.logoContainer}>
                                <span className={styles.logoText}>Ветеринарная клиника</span><br/>
                                <span className={styles.logoSubtext}>ЗООДОКТОР</span>
                            </div>
                        </Col>

                        {/* Иконки действий */}
                        <Col xs={6} className="text-end">
                            <div className="d-flex align-items-center justify-content-end gap-3">
                                <a
                                    href="tel:+79024777252"
                                    className={styles.mobilePhoneIcon}
                                >
                                    <CallIcon style={{fontSize: '1.5rem', color: '#0083b0'}}/>
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default MobileHeader;